module.exports = __webpack_public_path__ + "img/Group 106.336ced95.svg";